import React from 'react'

export enum RouterType {
  ReactRouter = 'react-router',
  NextJS = 'nextjs'
}

export const RouterContext = React.createContext(RouterType.ReactRouter)
